import templateUrl from 'emun.vendor/vendor-contact.popover.htm'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const VendorContactPopover = {
    open(options) {
        return modals.open(angular.extend({
            size: 'lg',
            // placement: 'right',
            //backdrop: false,
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: function(options) {
				let $ctrl = this;
                $ctrl.vendor = options.vendor;
                $ctrl.contactId = options.contactId;
                $ctrl.dismiss = function() {
                    const $ctrl = this;
                    $ctrl.$dismiss();
                }
            },
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

export default VendorContactPopover;